import styled from "styled-components"

import CenteredHero from "components/hero/centered"

export const Banner = styled(CenteredHero)`
  > div {
    border: none;
  }
`
